/**
 * Global session-expiry (401) handling with deduplication (spec §12.3).
 *
 * Several concurrent requests may 401 at once; this must produce AT MOST one
 * toast and one redirect. The QueryCache/MutationCache `onError` callbacks call
 * `notifySessionExpired()`, which collapses a burst within a short window and
 * notifies a single subscriber (mounted in the app) to clear caches, toast
 * once, and navigate to /login.
 */
const DEDUP_WINDOW_MS = 1500;

let lastHandledAt = 0;
const listeners = new Set<() => void>();

export function subscribeSessionExpired(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Returns true if this call actually triggered handling (i.e. not deduped). */
export function notifySessionExpired(now: number = Date.now()): boolean {
  if (now - lastHandledAt < DEDUP_WINDOW_MS) return false;
  lastHandledAt = now;
  for (const listener of listeners) listener();
  return true;
}

/** Test helper to reset the dedup window. */
export function resetSessionExpiryForTest(): void {
  lastHandledAt = 0;
}
